import Vue from 'vue';
import merge from 'lodash/merge';
import VModal from 'vue-js-modal';
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate';
import vSelect from 'vue-select';
import dmvPlugin from './system/plugins/dmv.plugin';
import $store from './system/store';
import $axios from './system/rest/axios';

Vue.use(dmvPlugin);

export default class {

    /**
     * @param {Object} options
     * @return {void}
     */
    registerVuelidate(options = {}) {
        Vue.use(Vuelidate, options);
    }

    /**
     * @param {Object} options
     * @return {void}
     */
    registerNotifications(options = {}) {
        Vue.use(Notifications, options);
    }

    /**
     * @param {Object} options
     * @return {void}
     */
    registerModal(options = {}) {
        const defaultOptions = {
            dialog:   true,
            defaults: {
                adaptive:   true,
                scrollable: true,
                height:     'auto',
                maxWidth:   500,
            }
        }
        Vue.use(VModal, merge({}, defaultOptions, options));
    }

    /**
     * @return {void}
     */
    registerVueSelect() {
        Vue.component('v-select', vSelect);
    }

    /**
     * @return {void}
     */
    registerAuthorization() {
        $axios.interceptors.request.use((config) => {
            const token = $store.getters['user/token'];

            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        });
    }
}

